<template>
  <v-autocomplete
    v-model="searchModel"
    :items="$store.state.tasks.tasks"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    item-text="title"
    item-value="id"
    label="Cauta dupa nume, telefon sau adresa"
    placeholder="Cauta"
    prepend-icon="search"
    no-filter
    return-object
    @change="editItem"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="text-h5 font-weight-light white--text"
      >
        {{ item.title.charAt(0) }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.title"></v-list-item-title>
        <v-list-item-subtitle
          >Client: {{ clientName(item) }}</v-list-item-subtitle
        >
        <v-list-item-subtitle>{{ formatAddress(item) }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SearchTask',
  data() {
    return {
      search: '',
      searchModel: null,
    };
  },

  watch: {
    search(query) {
      if (query) {
        this.searchTask(query);
      }
    },
  },

  methods: {
    ...mapActions('tasks', ['searchTask']),

    editItem(task) {
      setTimeout(() => {
        this.$router.push({ path: `/tasks/${task.id}` });
      }, 0);
    },
    clientName(item) {
      return item?.client?.name || 'nou';
    },

    formatAddress(event) {
      return (
        event?.address ||
        (event.client &&
          `${event.client.addressDetails},\n ${event.client.street},\n ${event.client.county}`)
      );
    },
  },
};
</script>
